import React from 'react';
import { Box, Chip, Avatar, IconButton, Typography, Grid } from '@mui/material';
import { Delete as DeleteIcon, Person } from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';

// Function to dynamically get the icon based on file type
const getFileIcon = (fileName) => {
  if (fileName.includes('pdf')) {
    return <PictureAsPdfIcon />;
  } else if (fileName.includes('image')) {
    return <ImageIcon />;
  } else {
    return <DescriptionIcon />; // Default for other file types
  }
};

const FileRole = ({ fileName }) => {
  return (
    <Grid container sx={{ marginTop: 2, justifyContent: 'flex-end' }}>
    <Grid item md={11.5} xs={11}>
<Box
sx={{
  
  maxWidth: '75%',
  color: 'white',
  padding: 1,
  marginRight:2,
  borderRadius: 2,
  float: 'right',
  textAlign: 'left',
}}

>
<Chip
          avatar={
            <Avatar sx={{ bgcolor: 'transparent', borderRadius: '2px' }}>
              {getFileIcon(fileName)}
            </Avatar>
          }
          label={`${fileName}`}
          variant="outlined"
          sx={{ flexGrow: 1, borderRadius: 1, borderColor:'dodgerBlue' }}
            />
</Box>
</Grid>
<Grid item md={0.5} xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
<Avatar sx={{ backgroundColor:'#0077B6', marginLeft: 0 }}>
  <Person />
</Avatar>
</Grid>

</Grid>
 
  );
};

export default FileRole;
